import PropTypes from 'prop-types';
import CharacterCounter from 'apps/interactions/components/character-counter';
import { useInteractionFormContext } from 'apps/interactions/form/context/interaction-form-context';
import { INTERACTION_CHARACTER_LIMIT } from 'apps/proposals/utils';

const SummaryField = ({ id, onChange, onBlur, name, value, required = false, field, meta, helpers }) => {
  const { interactionStandardFieldsConfig } = useInteractionFormContext();

  const maxLength = interactionStandardFieldsConfig?.summary?.max_length;
  const defaultMaxLength = INTERACTION_CHARACTER_LIMIT?.SUMMARY;
  const isRequired = interactionStandardFieldsConfig?.summary?.required;

  return (
    <>
      <input
        id={id}
        type="text"
        name={name}
        value={value}
        placeholder={`Add a summary${!isRequired ? ' (optional)...' : ''}`}
        onChange={onChange}
        onBlur={onBlur}
        // maxLength={maxLength} this seems like the easiest and best way to handle max length validation but :shrug:
      />
      {maxLength < defaultMaxLength && <CharacterCounter count={value?.length || 0} limit={maxLength} />}
    </>
  );
};

SummaryField.propTypes = {
  id: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  name: PropTypes.string,
  value: PropTypes.string,
  required: PropTypes.bool,
  field: PropTypes.shape({
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    value: PropTypes.any,
    checked: PropTypes.bool,
    multiple: PropTypes.bool,
  }),
  meta: PropTypes.shape({
    error: PropTypes.string,
    initialError: PropTypes.string,
    initialTouched: PropTypes.bool,
    initialValue: PropTypes.any,
    touched: PropTypes.bool,
    value: PropTypes.any,
  }),
  helpers: PropTypes.shape({
    setValue: PropTypes.func,
    setTouched: PropTypes.func,
    setError: PropTypes.func,
  }),
};
export default SummaryField;
